import React from "react";
import { Grid } from "@material-ui/core";
import R from "ramda";

import { useScreen } from "hooks";

import useStyles from "./useStyles";

const PlaceholderTileGroup = ({ cardsType, allCardsCount, ...gridProps }) => {
  const classes = useStyles();
  const { currentBreakpoint } = useScreen();

  const breakpoints = ["xs", "sm", "md", "lg", "xl"];

  const fitKeys = R.pipe(R.reverse, R.dropWhile(R.complement(R.equals(currentBreakpoint))))(breakpoints);
  const fitBreakpoint = fitKeys.find((k) => R.is(Number)(gridProps[k]));
  const value = gridProps[fitBreakpoint];

  const tilesOnRow = 12 / value;

  const placeholderCount = tilesOnRow - (allCardsCount % tilesOnRow);

  const renderPlaceholders = () => {
    const count = R.range(0, placeholderCount);
    return count.map((index) => {
      return (
        <Grid key={index} item {...gridProps}>
          <div className={classes.placeholder} />
        </Grid>
      );
    });
  };

  return renderPlaceholders();
};

export default PlaceholderTileGroup;
